import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const SupportSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.00006 13.4999C11.0376 13.4999 13.5001 11.0375 13.5001 7.99994C13.5001 4.96237 11.0376 2.49994 8.00006 2.49994C4.96249 2.49994 2.50006 4.96237 2.50006 7.99994C2.50006 11.0375 4.96249 13.4999 8.00006 13.4999ZM8.00006 14.9999C11.8661 14.9999 15.0001 11.8659 15.0001 7.99994C15.0001 4.13395 11.8661 0.999939 8.00006 0.999939C4.13407 0.999939 1.00006 4.13395 1.00006 7.99994C1.00006 11.8659 4.13407 14.9999 8.00006 14.9999ZM6.44026 4.53937C6.8702 4.1862 7.43439 3.97482 8.00007 3.97482C9.21726 3.97482 10.3395 4.79511 10.3395 6.11558C10.3395 6.49175 10.2615 6.86006 10.0421 7.21583C9.83371 7.55379 9.529 7.82877 9.16716 8.08226C8.94964 8.23464 8.84148 8.33905 8.78836 8.41026C8.75005 8.46163 8.75006 8.48069 8.75006 8.49887L8.75007 8.49972C8.75007 8.91394 8.41428 9.24972 8.00007 9.24972C7.58585 9.24972 7.25007 8.91394 7.25007 8.49972C7.25007 7.70501 7.79373 7.21296 8.30651 6.85374C8.58624 6.65777 8.70786 6.52176 8.76538 6.42848C8.81192 6.35302 8.8395 6.26984 8.8395 6.11558C8.8395 5.81637 8.59582 5.47482 8.00007 5.47482C7.79498 5.47482 7.56446 5.5571 7.39237 5.69846C7.22493 5.83599 7.16063 5.98523 7.16063 6.11558C7.16063 6.52979 6.82485 6.86558 6.41063 6.86558C5.99642 6.86558 5.66063 6.52979 5.66063 6.11558C5.66063 5.44249 6.00567 4.89635 6.44026 4.53937ZM8.00006 11.9999C8.55234 11.9999 9.00006 11.5522 9.00006 10.9999C9.00006 10.4477 8.55234 9.99994 8.00006 9.99994C7.44777 9.99994 7.00006 10.4477 7.00006 10.9999C7.00006 11.5522 7.44777 11.9999 8.00006 11.9999Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default SupportSvg;
